export default {
  newBadge: 'New!'
}
